import React from 'react';
import { Alert, Skeleton, Space, Typography } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useAuth } from '../../../hooks/useAuth';
import { useGetFlaggedResponseDetailQuery } from '../../../services/nestjs-base-api';
import { DetectorSignalsTable } from './DetectorSignalsTable';
import { AnswersTable } from './AnswersTable';

const { Text } = Typography;

interface ResponseQuickViewProps {
    responseId: number;
}

export const ResponseQuickView: React.FC<ResponseQuickViewProps> = ({
    responseId,
}) => {
    const { user } = useAuth();
    const { data, isLoading, isError } = useGetFlaggedResponseDetailQuery({
        jwtToken: user?.jwtToken || '',
        id: responseId,
    });

    if (isLoading) {
        return <Skeleton active paragraph={{ rows: 4 }} />;
    }
    if (isError || !data) {
        return (
            <Alert
                type="error"
                showIcon
                message={<FormattedMessage id="responseIntegrity.toast.error" />}
            />
        );
    }

    const signals = (data.signals || []).filter(
        (s: any) => Number(s.contributionScore) > 0,
    );

    return (
        <Space direction="vertical" size={16} style={{ width: '100%' }}>
            <div>
                <Text strong>
                    <FormattedMessage id="responseIntegrity.detail.tabs.signals" />
                </Text>
                <div style={{ marginTop: 8 }}>
                    <DetectorSignalsTable signals={signals} />
                </div>
            </div>
            <div>
                <Text strong>
                    <FormattedMessage id="responseIntegrity.detail.tabs.answers" />
                </Text>
                <div style={{ marginTop: 8 }}>
                    <AnswersTable answers={data.answers || []} />
                </div>
            </div>
        </Space>
    );
};
